import { BydPlanInterface } from '../interfaces/byd-plan.interface';

export class BydPlanModel {
  /**
   * Id of the plan
   */
  public id?: string;

  /**
   * Name of the plan
   */
  public name?: string;

  /**
   * Id of the creator
   */
  public userId?: number;

  /**
   * Id of the bim model the plan is attached to
   */
  public bimModelId?: number;

  /**
   * Create an instance of DsPlan.
   *
   * @param plan plan data
   */
  constructor(plan: BydPlanInterface) {
    this.id = plan.uuid;
    this.name = plan.name || '';
    this.userId = plan.userId || 0;
    this.bimModelId = plan.bimModelId || 0;
  }
}
